import { createV3Queries } from "@query/utils/createV3Queries";
import { recurringInvoicesApi } from "@api";

export const queriesRecurringInvoices = createV3Queries(
  "recurringInvoicesApi",
  recurringInvoicesApi
);
